import React from 'react';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";


const NextArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: 'block', background: 'black', color: 'white', borderRadius: '100%' }} 
      onClick={onClick}
    />
  );
};

const PrevArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: 'block', background: 'black', color: 'white', borderRadius: '100%' }} 
      onClick={onClick}
    />
  );
};

const Guide = () => {
  // Slider settings
  const settings = {
    dots: true,
    arrows: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    infinite: true,
    speed: 500,
    slidesToShow: 1,   // Always show one item
    slidesToScroll: 1,  // Scroll one item at a time
    autoplay: true,     // Enable automatic transitions
    autoplaySpeed: 3000, // Time in milliseconds between transitions (e.g., 3000ms = 3 seconds)
    responsive: [
      {
        breakpoint: 768, // For mobile devices
        settings: {
          slidesToShow: 1,  // Show 1 item
          slidesToScroll: 1,
          dots: true,
        }
      },
      {
        breakpoint: 1024, // For tablet and above
        settings: {
          slidesToShow: 1,  // Show 1 item
          slidesToScroll: 1,
        }
      }
    ]
  };

  const slides = [
    {
      image: require('../assets/images/slide.png'),
      title: 'Step 1',
      description: 'lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    },
    {
      image: require('../assets/images/slide.png'),
      title: 'Step 2',
      description: 'lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    },
    {
      image: require('../assets/images/slide.png'),
      title: 'Step 3',
      description: 'lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    },
    {
      image: require('../assets/images/slide.png'),
      title: 'Step 4',
      description: 'lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    }
  ];

  return (
    <div className='w-full bg-gray-200 pb-10'>
      <h1 className="w-11/12 mx-auto text-left text-2xl font-bold py-10">Guide:</h1>
      <div className='custom-slider-container w-11/12 mx-auto'>
        <Slider {...settings}>
          {slides.map((slide, index) => (
            <div key={index} className='relative h-screen mx-auto rounded-lg shadow-md flex items-center justify-center'>
              <img src={slide.image} alt={slide.title} className="w-full h-full object-cover rounded-lg" />
              
              {/* Slide content centered over the image */}
              <div className="absolute inset-0 flex flex-col items-center justify-center bg-black bg-opacity-40 rounded-lg">
                <h2 className='text-white text-3xl font-bold mb-4'>{slide.title}</h2>
                <p className='text-white text-lg'>{slide.description}</p>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
}

export default Guide;
